<template>
  <section-page title="Upgrade to use email integration" is-short>
    <p class="is-size-5 mt-200">In order to set up email integrations you will need to upgrade your Plan.</p>

    <button-outlined
      size=""
      class="mt-200 mb-100"
      @click="openBillingPortal"
    >Visit Billing Portal
    </button-outlined>
  </section-page>
</template>

<script>
export default {
  name: "EmailSettingsNotAvailableTab",
};
</script>
